import { StyleVars } from 'core/utils/Styles';

const spacingUnits = num => `${(num * StyleVars.defaultSpacingUnit)}px`;

export default spacingUnits;
